import consumer from "./consumer";

console.log("[PresenceChannel] Loading presence channel module...");
console.log("[PresenceChannel] Consumer:", consumer);

// Subscribe to PresenceChannel for real-time online user updates
const subscription = consumer.subscriptions.create("PresenceChannel", {
  connected() {
    console.log("[PresenceChannel] ✅ Connected to PresenceChannel");
    // Show online status badge as active
    const badge = document.getElementById("online-status-badge");
    console.log("[PresenceChannel] Badge element:", badge);
    if (badge) {
      badge.classList.remove("bg-secondary");
      badge.classList.add("bg-success");
      console.log("[PresenceChannel] Badge updated to success");
    } else {
      console.warn("[PresenceChannel] ⚠️ Badge element not found");
    }
  },

  disconnected() {
    console.log("[PresenceChannel] ❌ Disconnected from PresenceChannel");
    // Show online status badge as inactive
    const badge = document.getElementById("online-status-badge");
    if (badge) {
      badge.classList.remove("bg-success");
      badge.classList.add("bg-secondary");
      console.log(
        "[PresenceChannel] Badge updated to secondary (disconnected)"
      );
    }
  },

  received(data) {
    console.log("[PresenceChannel] 📨 Received data:", data);
    // Update online users count when broadcast is received
    if (data.type === "count_update") {
      const countElement = document.getElementById("online-users-count");
      console.log("[PresenceChannel] Count element:", countElement);
      console.log("[PresenceChannel] New count:", data.online_count);

      if (countElement) {
        countElement.textContent = data.online_count;

        // Add a subtle animation to highlight the update
        countElement.classList.add("text-success");
        setTimeout(() => {
          countElement.classList.remove("text-success");
        }, 1000);

        console.log(
          `[PresenceChannel] ✅ Online users updated: ${data.online_count} at ${data.timestamp}`
        );
      } else {
        console.warn("[PresenceChannel] ⚠️ Count element not found");
      }
    } else {
      console.warn("[PresenceChannel] Unknown data type:", data.type);
    }
  },
});

console.log("[PresenceChannel] Subscription created:", subscription);
